module.exports = __webpack_public_path__ + "img/placeholder-lands.da38ae25.svg";